// extracted by mini-css-extract-plugin
module.exports = {"fincalcPoweredBy":"CalculatorWrapper_fincalcPoweredBy__3LHI9","termsWrapper":"CalculatorWrapper_termsWrapper__3fDjX"};